import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose, withProps, lifecycle } from 'recompose';
import { connect } from 'formik';
import classnames from 'classnames';
import { Col, Row } from 'reactstrap';
import 'react-dates/initialize';
import { DayPickerRangeController } from 'react-dates';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendarAlt,
  faMinusCircle,
  faCheck,
  faTrashAlt,
} from '@fortawesome/pro-regular-svg-icons';
import { Tabs, Button } from '@stormideas/react-sdk';
import Activity from 'components/Activity';
import { FormRow, TextField } from 'components/Form';

import './FormActions.scss';
import moment from 'moment';
import UnscheduleModal from './UnscheduleModal';
import DeleteModal from './DeleteModal';

import { validateStartTime, validateEndTime } from './validation';
import '@stormideas/react-sdk/dist/components/Tabs/Tabs.scss';

const enhance = compose(
  connect,
  withProps(props => {
    const {
      formik: { status },
    } = props;

    if (status) {
      return {
        changingScheduledStatus: status.changingScheduledStatus,
      };
    }

    return { changingScheduledStatus: false };
  }),
  lifecycle({
    // eslint-cisable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.isSubmitting && !nextProps.isSubmitting) {
        if (
          this.props.changingScheduledStatus &&
          nextProps.changingScheduledStatus
        ) {
          nextProps.formik.setStatus({
            ...nextProps.formik.status,
            changingScheduledStatus: undefined,
          });
        }
      }
    },
  })
);
class FormActions extends Component {
  constructor(props) {
    super(props);
    const { formik } = props;

    let currentStartDate;
    let currentRemoveDate;

    if (formik.values) {
      currentStartDate = formik.values.publishAtDate;
      currentRemoveDate = formik.values.removeAtDate;
    }

    this.state = {
      focusedInput: props.autoFocusEndDate ? 'endDate' : 'startDate',
      startDate: (currentStartDate && moment(currentStartDate)) || null,
      endDate: (currentRemoveDate && moment(currentRemoveDate)) || null,
      showUnscheduleModal: false,
      showDeleteModal: false,
    };

    this.onDatesChange = this.onDatesChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onUnschedule = this.onUnschedule.bind(this);
    this.startTimeDisabled = this.startTimeDisabled.bind(this);
    this.endTimeDisabled = this.endTimeDisabled.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { formik } = this.props;
    const { values } = formik;

    if (prevProps.formik.values !== values) {
      let currentStartDate;
      let currentRemoveDate;

      if (values) {
        currentStartDate = values.publishAtDate;
        currentRemoveDate = values.removeAtDate;
      }

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        startDate: (currentStartDate && moment(currentStartDate)) || null,
        endDate: (currentRemoveDate && moment(currentRemoveDate)) || null,
      });
    }
  }

  onDatesChange({ startDate, endDate }) {
    const { formik } = this.props;

    // eslint-disable-next-line react/destructuring-assignment
    const currentStartDate = this.state.startDate;
    // eslint-disable-next-line react/destructuring-assignment
    const currentEndDate = this.state.endDate;

    if (currentStartDate === null && startDate !== null) {
      formik.setFieldValue('publishAtTime', '00:00');
    }

    if (currentEndDate === null && endDate !== null) {
      formik.setFieldValue('removeAtTime', '23:59');
    }

    if (currentEndDate !== null && endDate === null) {
      formik.setFieldValue('removeAtTime', '--:--');
    }

    formik.setFieldValue('publishAtDate', startDate);
    formik.setFieldValue('removeAtDate', endDate);

    formik.setFieldTouched('removeAtDate');

    this.setState({
      startDate,
      endDate,
    });
  }

  onFocusChange(focusedInput) {
    this.setState({ focusedInput: !focusedInput ? 'startDate' : focusedInput });
  }

  onUnschedule() {
    const { formik, handleSubmit } = this.props;
    formik.setFieldValue('publishAtDate', null);
    formik.setFieldValue('removeAtDate', null);
    formik.setFieldValue('publishAtTime', null);
    formik.setFieldValue('removeAtTime', null);
    handleSubmit();

    this.setState({
      showUnscheduleModal: false,
    });
  }

  onCancel() {
    this.setState({
      showUnscheduleModal: false,
    });
  }

  startTimeDisabled = values => {
    if (values && values.publishAtDate) {
      return false;
    }
    return true;
  };

  endTimeDisabled = values => {
    if (values && values.removeAtDate) {
      return false;
    }
    return true;
  };

  render() {
    const {
      focusedInput,
      startDate,
      endDate,
      showUnscheduleModal,
      showDeleteModal,
    } = this.state;
    const {
      activity,
      alert,
      changingScheduledStatus,
      children,
      extraActions,
      formik: { dirty, values, errors, touched },
      isSubmitting,
      nestedFieldName,
      preview,
      previewShow,
      setPreviewShow,
      showScheduling,
      schedulingRequired,
      isScheduled,
      isPublished,
      submitText,
      tabName,
      current,
      isValid,
      showDelete,
      onDelete,
    } = this.props;
    return (
      <div>
        <Tabs
          border="bottom"
          className="form-actions fieldset"
          content={[
            {
              tabName,
              tabContent: (
                <>
                  {!!children && <div className="form-group">{children}</div>}
                  {showScheduling && (
                    <div className="form-group">
                      <div
                        className={classnames(
                          'form__form-group-input-wrap--error-below date-picker',
                          {
                            'has-error': errors.removeAtDate,
                          }
                        )}
                      >
                        <DayPickerRangeController
                          startDate={startDate} // momentPropTypes.momentObj or null,
                          startDateId="publishAtDate"
                          endDate={endDate} // momentPropTypes.momentObj or null,
                          endDateId="removeAtDate"
                          onDatesChange={this.onDatesChange} // PropTypes.func.isRequired,
                          onFocusChange={this.onFocusChange} // PropTypes.func.isRequired,
                          block
                          enableOutsideDays
                          firstDayOfWeek={1}
                          focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                          horizontalMonthPadding={0}
                          minimumNights={0}
                          monthFormat="MMMM YYYY"
                          noBorder
                          verticalHeight={260}
                          weekDayFormat="ddd"
                          hideKeyboardShortcutsPanel
                        />
                        {errors.removeAtDate &&
                          touched &&
                          touched.removeAtDate && (
                            <small className="validation form__form-group-error invalid-feedback">
                              {errors.removeAtDate}
                            </small>
                          )}
                      </div>
                      <Row>
                        <Col xs={6}>
                          <FormRow
                            label="Start time (ET)"
                            name={`${
                              nestedFieldName
                                ? `${nestedFieldName}.publishAtTime`
                                : 'publishAtTime'
                            }`}
                            stacked
                          >
                            <TextField
                              name={`${
                                nestedFieldName
                                  ? `${nestedFieldName}.publishAtTime`
                                  : 'publishAtTime'
                              }`}
                              required={schedulingRequired}
                              type="time"
                              disabled={this.startTimeDisabled(values)}
                              validate={[
                                (field, value) =>
                                  validateStartTime(value, values),
                              ]}
                            />
                          </FormRow>
                        </Col>
                        <Col xs={6}>
                          <FormRow
                            label="End time (ET)"
                            name={`${
                              nestedFieldName
                                ? `${nestedFieldName}.removeAtTime`
                                : 'removeAtTime'
                            }`}
                            stacked
                          >
                            <TextField
                              name={`${
                                nestedFieldName
                                  ? `${nestedFieldName}.removeAtTime`
                                  : 'removeAtTime'
                              }`}
                              required={schedulingRequired}
                              type="time"
                              disabled={this.endTimeDisabled(values)}
                              validate={[
                                (field, value) =>
                                  validateEndTime(value, values),
                              ]}
                            />
                          </FormRow>
                        </Col>
                      </Row>
                    </div>
                  )}
                  {alert}
                  <div className="action-buttons">
                    {isScheduled && (
                      <Button
                        block
                        color="danger"
                        icon={<FontAwesomeIcon icon={faMinusCircle} />}
                        iconAfter={false}
                        outline
                        onClick={() =>
                          this.setState({
                            showUnscheduleModal: true,
                          })
                        }
                      >
                        Unschedule
                      </Button>
                    )}
                    {!isScheduled && tabName === 'Schedule' && (
                      <Button
                        block
                        className="btn-save-changes"
                        color="primary"
                        disabled={!dirty || !isValid}
                        icon={
                          <FontAwesomeIcon
                            icon={
                              submitText.toLowerCase() === 'schedule'
                                ? faCalendarAlt
                                : faCheck
                            }
                          />
                        }
                        iconAfter={false}
                        loading={isSubmitting && !changingScheduledStatus}
                        type="submit"
                      >
                        {submitText}
                      </Button>
                    )}
                    {showDelete && (
                      <Button
                        block
                        color="danger"
                        icon={<FontAwesomeIcon icon={faTrashAlt} />}
                        iconAfter={false}
                        outline
                        onClick={() =>
                          this.setState({
                            showDeleteModal: true,
                          })
                        }
                      >
                        Delete
                      </Button>
                    )}
                    {tabName !== 'Schedule' && (
                      <Button
                        block
                        className="btn-save-changes"
                        color="primary"
                        disabled={!isValid}
                        icon={
                          <FontAwesomeIcon
                            icon={
                              submitText.toLowerCase() === 'schedule'
                                ? faCalendarAlt
                                : faCheck
                            }
                          />
                        }
                        iconAfter={false}
                        loading={isSubmitting}
                        type="submit"
                      >
                        {submitText}
                      </Button>
                    )}
                    {extraActions}
                  </div>
                </>
              ),
            },
            !!preview && {
              tabName: 'Preview',
              tabContent: previewShow && preview,
            },
            !!activity && {
              tabName: 'Activity',
              tabContent: (
                <Activity
                  action="scheduled by"
                  imgSrc="https://placedog.net/72/72"
                  name="Rick Mason"
                  timestamp="Yesterday at 4:37 pm"
                />
              ),
            },
          ]}
          justify={false}
          onChange={
            !!preview &&
            ((tab, name) => {
              if (name && name === 'Preview') {
                setPreviewShow(true);
              } else {
                setPreviewShow(false);
              }
            })
          }
        />
        {showUnscheduleModal && (
          <UnscheduleModal
            title={current && current.title}
            onCancel={this.onCancel}
            onUnschedule={this.onUnschedule}
            isPublished={isPublished}
            entityName="ad"
          />
        )}
        {showDeleteModal && (
          <DeleteModal
            title={current && current.title}
            onCancel={this.onCancel}
            onDelete={() => {
              onDelete();
              this.setState({
                showDeleteModal: false,
              });
            }}
            isPublished={isPublished}
            entityName="ad"
          />
        )}
      </div>
    );
  }
}

FormActions.propTypes = {
  /** Activity tab contents */
  activity: PropTypes.node,
  /** Additional info */
  alert: PropTypes.node,
  /** Legacy prop form Hallmark MC publishing flow */
  changingScheduledStatus: PropTypes.bool,
  /** Additional nodes, currently used for flexibility while we nail down the UX */
  children: PropTypes.node,
  /** Additional actions below the submit button */
  extraActions: PropTypes.node,
  /** Formik object */
  formik: PropTypes.shape({
    errors: PropTypes.shape({
      removeAtDate: PropTypes.string,
    }),
    touched: PropTypes.shape({
      removeAtDate: PropTypes.bool,
    }),
    values: PropTypes.shape({
      publishAtDate: PropTypes.string,
      publishAtTime: PropTypes.string,
      removeAtDate: PropTypes.string,
      removeAtTime: PropTypes.string,
    }),
    dirty: PropTypes.bool.isRequired,
    setFieldTouched: PropTypes.func,
    setFieldValue: PropTypes.func,
  }).isRequired,
  handleSubmit: PropTypes.func,
  /** Triggers loading state on the save button */
  isSubmitting: PropTypes.bool,
  /** In device preview */
  preview: PropTypes.node,
  /** Callback function for when Preview tab becomes active */
  previewShow: PropTypes.func,
  /** Passing state from parent? */
  setPreviewShow: PropTypes.func,
  /** Legacy, show scheduling options */
  showScheduling: PropTypes.bool,
  /** Legacy, must be scheduled */
  schedulingRequired: PropTypes.bool,
  isScheduled: PropTypes.bool,
  nestedFieldName: PropTypes.string,
  submitText: PropTypes.string,
  tabName: PropTypes.string,
  autoFocusEndDate: PropTypes.bool,
  current: PropTypes.shape({
    title: PropTypes.string,
  }),
  isPublished: PropTypes.bool,
  isValid: PropTypes.bool,
  showDelete: PropTypes.bool,
  onDelete: PropTypes.func,
};

FormActions.defaultProps = {
  activity: null,
  alert: null,
  changingScheduledStatus: false,
  children: null,
  extraActions: null,
  isSubmitting: false,
  preview: null,
  previewShow: null,
  setPreviewShow: false,
  showScheduling: false,
  schedulingRequired: false,
  isScheduled: false,
  nestedFieldName: '',
  submitText: 'Save',
  tabName: 'Actions',
  autoFocusEndDate: false,
  current: null,
  handleSubmit: null,
  isPublished: false,
  isValid: false,
  showDelete: false,
  onDelete: () => {},
};

export default enhance(FormActions);
